import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ theme }) => css`
    max-height: 300px;
    min-width: 320px;
    border: 1px solid #E3E3E3;
    border-radius: 8px;
    overflow-y: auto;
    background: white;
    padding-top: 0px;

    scrollbar-width: thin;
    scrollbar-color: #E3E3E3 transparent;
    /* width */
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    /* Track */
    ::-webkit-scrollbar-track {
      border-radius: 10px;
    }
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${`${theme?.colour?.primary}8D`};
    }
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${`${theme?.colour?.primary}8D`};
    }
  `}
`

export default Wrapper(template)